import {useHistory} from "react-router-dom";
import {useEffect} from "react";

const RedirectToHomePage = () => {
    let history = useHistory();

    useEffect(() => {
        history.push(`/workflow/main-home-page`)
        return function cleanup() {
        }
    }, []);

    return (
        <div>
            <h1>Please wait..</h1>
        </div>
    )
}
export default RedirectToHomePage
